import React from 'react';
const ChannelsConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/channels/Whatsapp',
			component: React.lazy(() => import('./WhatsappChannelSteps'))
		},
		{
			path: '/channels/fb-page',
			component: React.lazy(() => import('./FBPagesChannelSteps'))
		},
		{
			path: '/channels/facebook/posts',
			component: React.lazy(() => import('./facebookPost.js'))
		},
		{
			path: '/channels/Instagram',
			component: React.lazy(() => import('./instagramChannel'))
		},
		{
			path: '/channels/TikTok',
			component: React.lazy(() => import('./tiktokChannel'))
		},
		{
			path: '/channels/WebChat',
			component: React.lazy(() => import('./webChannel'))
		},
		{
			path: '/channels/sms',
			component: React.lazy(() => import('./SMSChannel'))
		},
		{
			path: '/channels/webchat-btn',
			component: React.lazy(() => import('./FreeChatBtn.js'))
		},
		{
			path: '/channels/fbchannels',
			component: React.lazy(() => import('./messengerChannel.js'))
		},
		{
			path: '/channels/fb',
			component: React.lazy(() => import('./fbChannel.js'))
		},
		{
			path: '/channels/domain',
			component: React.lazy(() => import('./domainChannel/DomainChannel.js'))
		},
		{
			path: '/channels/voice-portal',
			component: React.lazy(() => import('./VoicePortal.js'))
		},
		{
			path: '/channels/email-inbox',
			component: React.lazy(() => import('./emailInboxChannel/EmailInboxChannel'))
		},
		{
			path: '/channels',
			component: React.lazy(() => import('./index.js'))
		},
	]
};

export default ChannelsConfig;
